import React from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';

const UboEnteredOnline = props => {
  const intl = useIntl();
  const { log } = props;

  const dateTime = moment.utc(log.newValue).local(false);
  const time = dateTime.format('LLLL');

  return <span>{intl.formatMessage(messages.UboSnapshotEnteredOnline, { time })}</span>;
};

export default UboEnteredOnline;
